import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateHappyFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-4 9a2 2 0 1 1-2 2 2 2 0 0 1 2-2m9.71 9.71A8.5 8.5 0 0 1 16 23a8.5 8.5 0 0 1-5.71-2.29 1 1 0 0 1 1.42-1.42 6.24 6.24 0 0 0 8.58 0 1 1 0 0 1 1.42 1.42M20 15a2 2 0 1 1 2-2 2 2 0 0 1-2 2" /></svg>;
const ForwardRef = forwardRef(IconRateHappyFilledSVG);
ForwardRef.displayName = "IconRateHappyFilled";
export { ForwardRef as IconRateHappyFilled };